import $ from 'jquery';

$(document).ready(function() {
    $(document).on('click', '.js-calendar-filter-map-button', function() {
        $(this).toggleClass('active');
        if ($(this).hasClass('active')) {
            $('.js-calendar-filter-map').slideDown();
        } else {
            $('.js-calendar-filter-map').slideUp();
        }
    });
    $(document).on('click', '.js-calendar-filter-map-button-routes', function() {
        if ($(this).hasClass('active')) {
    		$(this).find('span').text("Скрыть карту");
        } else {
    		$(this).find('span').text("Открыть карту");
        }
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/calendar/calendar-map.js